import clsx from "clsx";
import { useForm as useFormHook } from "hooks";
import { converStringtoArray } from "util/transformers";
import type { HighRiskMerchant } from 'features/ecommerce/types';
import {
    FormField,
    type OnboardingFinancialInformation,
    type OnboardingFinancialInformationForm
} from "./types";
import useValidationSchema from "./useValidationSchema";

export const getInitialValues = ({
    preferredCurrency = null,
    avgTransactionNoMonth,
    maxTransactionVolumeMonth,
    currentPercentChargebacksRefundsRatio,
    expectedSalesVolumeMonth,
    maxTransactionNoCustomerMonth,
    estimatedPercentChargebacksRefundsMonth,
    transactionNoCurrentMonth,
    avgTransactionAmount,
    maxTransactionAmount,
    salesVolumeCurrentMonth,
    isProcessingHistoryOverSixMonths,
    usedPsps,
    hasLeftPreviousProcessors,
    leftPreviousProcessorsInput,
    salesCurrencies,
    totalTransactionAmountYearly
}: Partial<HighRiskMerchant.OnboardingFinancialInformation>): OnboardingFinancialInformation => ({
    [FormField.PreferredCurrency]: preferredCurrency,
    [FormField.AvgTransactionNoMonth]: clsx(avgTransactionNoMonth),
    [FormField.MaxTransactionVolumeMonth]: clsx(maxTransactionVolumeMonth),
    [FormField.CurrentPercentChargebacksRefundsRatio]: clsx(currentPercentChargebacksRefundsRatio),
    [FormField.ExpectedSalesVolumeMonth]: clsx(expectedSalesVolumeMonth),
    [FormField.MaxTransactionNoCustomerMonth]: clsx(maxTransactionNoCustomerMonth),
    [FormField.EstimatedPercentChargebacksRefundsMonth]: clsx(estimatedPercentChargebacksRefundsMonth),
    [FormField.TransactionNoCurrentMonth]: clsx(transactionNoCurrentMonth),
    [FormField.AvgTransactionAmount]: clsx(avgTransactionAmount),
    [FormField.MaxTransactionAmount]: clsx(maxTransactionAmount),
    [FormField.SalesVolumeCurrentMonth]: clsx(salesVolumeCurrentMonth),
    [FormField.IsProcessingHistoryOverSixMonths]: isProcessingHistoryOverSixMonths ?? null,
    [FormField.UsedPsps]: clsx(usedPsps),
    [FormField.HasLeftPreviousProcessors]: hasLeftPreviousProcessors ?? null,
    [FormField.LeftPreviousProcessorsInput]: clsx(leftPreviousProcessorsInput),
    [FormField.SalesCurrencies]: converStringtoArray(salesCurrencies),
    [FormField.TotalTransactionAmountYearly]: clsx(totalTransactionAmountYearly)
});

export const useForm = (onboardingFinancialInformation: OnboardingFinancialInformationForm) =>
    useFormHook({
        isInitialValid: false,
        ...onboardingFinancialInformation,
        validateOnMount: true,
        validationSchema: useValidationSchema()
    });
